import React, { useState, useEffect } from "react";
import { saveUserProfile, getUserProfile } from "../firebase";
import { toast } from "react-toastify";

const conditionOptions = [
  "Type 1 diabetes",
  "Type 2 diabetes",
  "Pre-diabetes",
  "Gestational diabetes"
];

function UserProfile({ user, condition, setCondition }) {
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const loadProfile = async () => {
      if (!user?.uid) return;
      try {
        const profile = await getUserProfile(user.uid);
        if (profile?.condition) {
          setCondition(profile.condition);
        }
      } catch (err) {
        console.error("Failed to load profile:", err);
      }
      setLoading(false);
    };

    loadProfile();
  }, [user, setCondition]);

  const handleSave = async () => {
    try {
      await saveUserProfile({ uid: user.uid, email: user.email, condition });
      toast("Condition updated successfully!", {
        type: "success",
        position: "top-center",
        icon: "✅"
      });
    } catch (err) {
      console.error("Error saving profile:", err);
      toast.error("Failed to update condition.");
    }
  };

  if (!user?.uid || loading) return null;

  return (
    <div style={{ marginTop: "2rem", padding: "0.5rem", border: "1px solid #ccc", borderRadius: 8 }}>
    {/* <div style={{ marginTop: "2rem"}}> */}
      <button onClick={() => setExpanded(!expanded)} style={{ marginBottom: "0.5rem" }}>
        {expanded ? "▲ Hide Settings" : "▼ Show Settings"}
      </button>


      {expanded && (
        <>
          {/* Show active condition always below button */}
          <div style={{ fontStyle: "italic", marginBottom: "1rem" }}>

            <label htmlFor="condition">Condition to manage:</label><br />
            <select
              id="condition"
              value={condition}
              onChange={(e) => setCondition(e.target.value)}
              style={{ marginTop: "0.5rem", marginBottom: "1rem", width: "80%" }}
            >
              {conditionOptions.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select><br />
            <button onClick={handleSave}>Save Condition</button>
          </div>
        </>
      )}
    </div>

  );
}

export default UserProfile;
